export const TYPES = Object.freeze({
  EMPTY: 'empty',
  BOOLEAN: 'boolean',
  NUMBER: 'number',
  DATE: 'date',
  EMAIL: 'email',
  TEXT: 'text',
  MIXED: 'mixed',
});

const EMAIL_RE = /^[\w.+-]+@[\w-]+\.[\w.-]+$/i;
const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}([ T]\d{2}:\d{2}(:\d{2})?(\.\d+)?(Z|[+-]\d{2}:?\d{2})?)?$/;
const SLASH_DATE_RE = /^\d{1,2}[\/\-]\d{1,2}[\/\-]\d{2,4}([ T]\d{1,2}:\d{2}(:\d{2})?)?$/;
const BOOLEAN_VALUES = new Set([
  'true', 'false', 'yes', 'no', 'sí', 'si', 'no',
  '1', '0', 'y', 'n', 's', 'on', 'off', 'verdadero', 'falso',
]);

function classifySingle(value) {
  if (value === null || value === undefined || value === '') return TYPES.EMPTY;
  if (value instanceof Date && !isNaN(value)) return TYPES.DATE;
  if (typeof value === 'boolean') return TYPES.BOOLEAN;
  if (typeof value === 'number') return Number.isFinite(value) ? TYPES.NUMBER : TYPES.EMPTY;

  const str = String(value).trim();
  if (str === '') return TYPES.EMPTY;
  const lower = str.toLowerCase();

  if (BOOLEAN_VALUES.has(lower) && (lower === 'true' || lower === 'false' || lower === 'yes' || lower === 'no' || lower === 'sí' || lower === 'verdadero' || lower === 'falso')) {
    return TYPES.BOOLEAN;
  }
  if (EMAIL_RE.test(str)) return TYPES.EMAIL;
  if (ISO_DATE_RE.test(str) || SLASH_DATE_RE.test(str)) return TYPES.DATE;

  if (/^-?\d+([.,]\d+)?$/.test(str.replace(/\s/g, ''))) return TYPES.NUMBER;

  return TYPES.TEXT;
}

const DOMINANT_THRESHOLD = 0.9;

export function detectColumnType(values, options = {}) {
  const limit = options.sampleLimit ?? 1000;
  const counts = {
    [TYPES.BOOLEAN]: 0,
    [TYPES.NUMBER]: 0,
    [TYPES.DATE]: 0,
    [TYPES.EMAIL]: 0,
    [TYPES.TEXT]: 0,
  };

  let total = 0;
  let i = 0;
  while (i < values.length && total < limit) {
    const cls = classifySingle(values[i]);
    if (cls !== TYPES.EMPTY) {
      counts[cls] = (counts[cls] || 0) + 1;
      total += 1;
    }
    i += 1;
  }

  if (total === 0) return TYPES.EMPTY;

  let dominant = TYPES.TEXT;
  let dominantCount = 0;
  for (const [type, count] of Object.entries(counts)) {
    if (count > dominantCount) {
      dominant = type;
      dominantCount = count;
    }
  }

  const ratio = dominantCount / total;
  if (ratio >= DOMINANT_THRESHOLD) return dominant;

  if (counts[TYPES.NUMBER] + counts[TYPES.DATE] === total && counts[TYPES.DATE] > 0 && counts[TYPES.NUMBER] > 0) {
    return TYPES.DATE;
  }

  return TYPES.MIXED;
}

export function classifyValue(value) {
  return classifySingle(value);
}
